// extracted by mini-css-extract-plugin
module.exports = {"videoPage":"VideoPreviewPage_videoPage__MbUle"};